import { TextField } from '@mui/material';

interface Prop {
  value: string;
  onChange: (value: string) => void;
}

function DatePicker({ value, onChange }: Prop) {
  return (
    <TextField
      name="from"
      label="From"
      type="date"
      size="small"
      fullWidth
      value={value || ''}
      onChange={(e) => {
        if (e.target.value) {
          onChange(e.target.value);
        }
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
        },
      }}
      InputLabelProps={{ shrink: true }}
    />
  );
}

export default DatePicker;
